import styled from '@emotion/styled'

export const Conditions = styled.div`
  align-items: flex-start;
  display: flex;
  width: 100%;
`
